const carouselItems = [
  {
    title: '2024年度完结日漫大盘点',
    desc: '今年完结的日漫全集佳作一网打尽，从热血战斗到治愈温情，下拉式全集一次看够。',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20Japanese%20manga%20collage%20featuring%20multiple%20popular%20anime%20characters%20in%20warm%20energetic%20composition%2C%20festive%20celebration%20theme%2C%20cream%20background%20with%20colorful%20accents%2C%20editorial%20illustration%20style&width=1200&height=600&seq=carousel-01&orientation=landscape',
    badge: '年度专题',
    badgeColor: 'bg-primary-100 text-primary-700',
  },
  {
    title: '韩漫完结神作推荐榜',
    desc: '必看的韩漫全集清单，从甜蜜恋爱到悬疑惊悚，每一部都是下拉式阅读的极致享受。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20webtoon%20style%20illustration%20showcasing%20romantic%20and%20dramatic%20scenes%2C%20soft%20warm%20lighting%2C%20clean%20modern%20aesthetic%20with%20cream%20background%2C%20editorial%20quality&width=1200&height=600&seq=carousel-02&orientation=landscape',
    badge: '韩漫特辑',
    badgeColor: 'bg-accent-100 text-accent-700',
  },
  {
    title: '热血战斗漫画全集合集',
    desc: '战斗漫爱好者必收！从经典到新锐，热血日漫全集一次性推荐，下拉式看完全部章节。',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20manga%20illustration%20with%20multiple%20warriors%20in%20battle%20poses%2C%20epic%20energy%20effects%20in%20warm%20orange%20and%20red%2C%20clean%20cream%20background%2C%20powerful%20composition&width=1200&height=600&seq=carousel-03&orientation=landscape',
    badge: '热血专题',
    badgeColor: 'bg-primary-100 text-primary-700',
  },
  {
    title: '校园恋爱漫画精选全集',
    desc: '青春不散场！精选校园恋爱完结漫画大全，从初恋到成长，下拉式全集甜蜜不间断。',
    img: 'https://readdy.ai/api/search-image?query=Gentle%20romantic%20manga%20illustration%20of%20young%20couples%20in%20school%20setting%20with%20cherry%20blossoms%2C%20soft%20warm%20pink%20tones%2C%20clean%20cream%20background%2C%20dreamy%20atmosphere&width=1200&height=600&seq=carousel-04&orientation=landscape',
    badge: '恋爱特辑',
    badgeColor: 'bg-accent-100 text-accent-700',
  },
  {
    title: '新人入坑指南：完结漫画推荐',
    desc: '漫画新人看这里！精选最适合入门的完结漫画全集，下拉式阅读轻松上手，漫画大全入门篇。',
    img: 'https://readdy.ai/api/search-image?query=Welcoming%20manga%20illustration%20with%20diverse%20popular%20characters%20waving%20and%20smiling%2C%20friendly%20inviting%20atmosphere%2C%20warm%20cream%20background%20with%20soft%20colorful%20elements%2C%20beginner%20friendly%20vibe&width=1200&height=600&seq=carousel-05&orientation=landscape',
    badge: '入门指南',
    badgeColor: 'bg-secondary-100 text-secondary-700',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-4">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-xl mx-auto">
          精心策划的漫画全集专题，帮你快速发现值得看的完结作品
        </p>

        <div className="grid grid-cols-1 gap-5">
          {carouselItems.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="group flex flex-col sm:flex-row bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative w-full sm:w-72 flex-shrink-0 overflow-hidden">
                <img
                  src={item.img}
                  alt={`亲亲漫画网 - ${item.title}`}
                  className="w-full h-48 sm:h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className={`absolute top-3 left-3 px-3 py-1 rounded-full text-xs font-medium ${item.badgeColor}`}>
                  {item.badge}
                </span>
              </div>
              <div className="flex-1 p-5 sm:p-6 flex flex-col justify-center">
                <h3 className="text-base md:text-lg font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                <span className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-primary-600">
                  查看详情 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}